import type { AgendaModule } from "@repo/types";
import { AgendaItemDisplay } from "../agendaItems/AgendaItemDisplay";
import { AgendaDisplay } from "../agendas/AgendaDisplay";

export const AgendaItems = ({
  tenantId,
  agendaModule,
}: {
  tenantId: string;
  agendaModule: AgendaModule;
}) => {
  return (
    <>
      <div className="p-2">
        <h1 className="text-2xl">Agenda Items</h1>
        <div className="flex flex-col pt-4">
          {agendaModule.agendaItemIds?.map((agendaItemId) => (
            <AgendaItemDisplay
              key={agendaItemId}
              agendaItemId={agendaItemId}
              tenantId={tenantId}
            />
          ))}
        </div>
      </div>
      <div className="p-2">
        <h1 className="text-2xl">Meeting Used On</h1>
        <div className="flex flex-col pt-4">
          {agendaModule.parentIds?.map((agendaId) => (
            <AgendaDisplay
              key={agendaId}
              agendaId={agendaId}
              tenantId={tenantId}
            />
          ))}
        </div>
      </div>
    </>
  );
};
